import React from "react";
import "./index.css"

const MarketFilter = ({content}) => {
    return (
        <li className="marketFilter">{content}</li>
    )
}

export default MarketFilter